import PropTypes from "prop-types"
import classNames from "classnames"
import { StarRounded } from "@mui/icons-material"

function TooltipItem({ label, color, formatter, value, favorite, focused, id }) {
  return <div className={classNames("components_charts_color-tooltip-item", {
    favorite,
    focused: focused && focused === id,
    hidden: focused && focused !== id,
  })}
  >
    {favorite
      ? <StarRounded className="star-icon" style={{ color }} />
      : <span className="color" style={{ backgroundColor: color }} />}
    <span className="dimension">{label}</span>
    <span className="value">{formatter ? formatter(value) : value}</span>
  </div>
}

TooltipItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  favorite: PropTypes.bool,
  focused: PropTypes.string,
  formatter: PropTypes.func,
  value: PropTypes.number,
}

export default TooltipItem
